import { get, post, form, put, delete1 } from '../utils/httpUtils';
import { message } from 'antd';
import { dispatch } from '../App';

const defaultPageSize = 10;
const domain = 'api.jinchim.com';
const apiBaseUrl = 'http://' + domain + '/v1/';


const role = {
    admin: 1,
    test: 2,
    teacher: 10,
    student: 100,
    patraiarch: 101
}

const api = {
    login: {
        url: apiBaseUrl + 'session',
        params: function (username, password) {
            return { username: username, password: password }
        }
    },
    getPlatform: {
        url: apiBaseUrl + 'platform',
        params: function (name, pageNumber, pageSize) {
            return { name: name, pageNumber: pageNumber, pageSize: pageSize }
        }
    },
    getPlatformDetail: {
        url: function (id) {
            return apiBaseUrl + 'platform/' + id;
        }
    },
    addPlatform: {
        url: apiBaseUrl + 'platform',
        params: function (name, url) {
            return { name: name, url: url }
        }
    },
    updatePlatform: {
        url: function (id) {
            return apiBaseUrl + 'platform/' + id;
        },
        params: function (name, url) {
            return { name: name, url: url }
        }
    },
    deletePlatform: {
        url: function (id) {
            return apiBaseUrl + 'platform/' + id;
        }
    },
    getAccount: {
        url: apiBaseUrl + 'account',
        params: function (name, username, pageNumber, pageSize) {
            return { name: name, username: username, pageNumber: pageNumber, pageSize: pageSize }
        }
    },
    getAccountDetail: {
        url: function (id) {
            return apiBaseUrl + 'account/' + id;
        }
    },
    addAccount: {
        url: apiBaseUrl + 'account',
        params: function (platformId, username, password, tag) {
            return { platformId: platformId, username: username, password: password, tag: tag }
        }
    },
    updateAccount: {
        url: function (id) {
            return apiBaseUrl + 'account/' + id;
        },
        params: function (username, password, tag) {
            return { username: username, password: password, tag: tag }
        }
    },
    deleteAccount: {
        url: function (id) {
            return apiBaseUrl + 'account/' + id;
        }
    },
    getHuobi: {
        url: apiBaseUrl + 'huobi'
    },
    getHuobiInvestment: {
        url: apiBaseUrl + 'huobi-investment',
        params: function (symbol, pageNumber, pageSize) {
            return { symbol: symbol, pageNumber: pageNumber, pageSize: pageSize }
        }
    },
    getHuobiInvestmentDetail: {
        url: function (id) {
            return apiBaseUrl + 'huobi-investment/' + id;
        }
    },
    addHuobiInvestment: {
        url: apiBaseUrl + 'huobi-investment',
        params: function (symbol, type, price, volume, commission, totalPrice) {
            return { symbol: symbol, type: type, price: price, volume: volume, commission: commission, totalPrice: totalPrice }
        }
    },
    updateHuobiInvestment: {
        url: function (id) {
            return apiBaseUrl + 'huobi-investment/' + id;
        },
        params: function (symbol, type, price, volume, commission, totalPrice) {
            return { symbol: symbol, type: type, price: price, volume: volume, commission: commission, totalPrice: totalPrice }
        }
    },
    deleteHuobiInvestment: {
        url: function (id) {
            return apiBaseUrl + 'huobi-investment/' + id;
        }
    },
    getHuobiInvestmentProfitLoss: {
        url: apiBaseUrl + 'huobi-investment-profit-loss',
        params: function (symbol) {
            return { symbol: symbol }
        }
    },
    getHuobiInvestmentSymbol: {
        url: apiBaseUrl + 'huobi-investment-symbol'
    },
    getOKEx: {
        url: apiBaseUrl + 'okex',
        params: function (type) {
            return { type: type }
        }
    },
    getOKExDetail: {
        url: function (id) {
            return apiBaseUrl + 'okex/' + id;
        }
    },
    addOKExContractQuant: {
        url: apiBaseUrl + 'okex-contract-quant',
        params: function (instrumentId, model, type, parameters, backTestBeginTime, backTestEndTime) {
            return { instrumentId: instrumentId, model: model, type: type, parameters: parameters, backTestBeginTime: backTestBeginTime, backTestEndTime: backTestEndTime }
        }
    },
    updateOKExContractQuant: {
        url: function (id) {
            return apiBaseUrl + 'okex-contract-quant/' + id;
        },
        params: function (status) {
            return { status: status }
        }
    },
    deleteOKExContractQuant: {
        url: function (id) {
            return apiBaseUrl + 'okex-contract-quant/' + id;
        }
    },
    getOKExContractInfo: {
        url: apiBaseUrl + 'okex-contract-info'
    },
    download: {
        url: function () {
            return apiBaseUrl + 'download';
        }
    }
}

function onGet(url, data) {
    let queryString = '?';
    for (let key in data) {
        if (data[key] === null || data[key] === '' || data[key] === undefined) {
            continue
        }
        queryString += key + '=' + data[key] + '&';
    }
    return get(url + queryString, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(status => {
        if (status === 401) {
            dispatch.common.isLogin(false);
        } else {
            message.error('网络通讯失败');
        }
    });
}

function onPost(url, data) {
    return post(url, data, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(status => {
        if (status === 401) {
            dispatch.common.isLogin(false);
        } else {
            message.error('网络通讯失败');
        }
    });
}

function onForm(url, formData, callback) {
    return form(url, formData, localStorage.getItem('token'), callback).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(status => {
        if (status === 401) {
            dispatch.common.isLogin(false);
        } else {
            message.error('网络通讯失败');
        }
    });
}

function onPut(url, data) {
    return put(url, data, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(status => {
        if (status === 401) {
            dispatch.common.isLogin(false);
        } else {
            message.error('网络通讯失败');
        }
    });
}

function onDelete(url, data) {
    return delete1(url, data, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(status => {
        if (status === 401) {
            dispatch.common.isLogin(false);
        } else {
            message.error('网络通讯失败');
        }
    });
}

export {
    defaultPageSize,
    domain,
    api,
    role,
    onGet,
    onPost,
    onForm,
    onPut,
    onDelete
}


// WEBPACK FOOTER //
// ./src/core/api.js